'use client'
import type { ReactNode } from 'react'

import {
  SidebarLayoutProvider,
  useSidebarLayout,
} from './use-sidebar-layout.ts'

type SidebarLayoutProps = Readonly<{
  children?: ReactNode
}>

const SidebarLayout = ({ children }: SidebarLayoutProps) => {
  const context = useSidebarLayout()

  return (
    <SidebarLayoutProvider value={context}>
      <div>{children}</div>
    </SidebarLayoutProvider>
  )
}

export { SidebarLayout, type SidebarLayoutProps }
